import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { AppConfigService } from '@app_services/appconfigservice';
import { ASSETS, Locations } from './asset_locations';
// import { siteUrl } from './BSPreset';
@Injectable({
  providedIn: 'root',
})
export class ThemeServiceService {
  private document = inject<Document>(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  private appConfigService = inject(AppConfigService);

  // environment: EnvironmentEnum = 'DEV';
  init() {
    if (isPlatformBrowser(this.platformId)) {
      // if (
      //   !this.document.location.host ||
      //   this.document.location.host.indexOf('localhost') > -1 ||
      //   this.document.location.host.indexOf('127.0.0.1') > -1
      // ) {
      //   this.environment = 'DEV';
      // } else if (this.document.location.host.indexOf('stage') > -1) {
      //   this.environment = 'STAGE';
      // } else {
      //   this.environment = 'PROD';
      // }
      this.replaceThemeHref('styles.scss');

      this.applyTheme();
    }
  }

  applyTheme() {
    const siteConfig = ASSETS.find(asset =>
      asset.hostname.includes(window.location.hostname),
    );

    if (siteConfig) {
      this.changeFavicon(siteConfig.favicon ?? '', siteConfig.brand);
      this.setThemeVariables(siteConfig);
    } else {
      document.documentElement.style.setProperty(
        '--white-label-header-text-color',
        '#fff',
      );
      console.warn(
        'No theme configuration found for hostname:',
        window.location.hostname,
      );
    }
    return siteConfig;
  }

  changeFavicon(faviconURL: string, title: string) {
    let link: HTMLLinkElement = document.querySelector("link[rel~='icon']")!;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconURL;
    const pageTitle = this.toTitleCase(title);
    document.title = `${pageTitle} Portal`;
  }

  toTitleCase(str: string) {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  private replaceThemeHref(href: string) {
    const id = 'theme-link';
    const themeLink = <HTMLLinkElement>this.document.getElementById(id);
    if (!themeLink) {
      return;
    }
    const cloneLinkElement = <HTMLLinkElement>themeLink.cloneNode(true);

    cloneLinkElement.setAttribute('href', href);
    cloneLinkElement.setAttribute('id', id + '-clone');

    const themeLoadListener = () => {
      themeLink.remove();
      cloneLinkElement.setAttribute('id', id);
      cloneLinkElement.removeEventListener('load', themeLoadListener);
    };

    themeLink.parentNode!.insertBefore(cloneLinkElement, themeLink.nextSibling);
    cloneLinkElement.addEventListener('load', themeLoadListener);
  }

  private setThemeVariables(siteConfig: Locations) {
    const themeVars = {
      '--white-label-bg-color': siteConfig.bg_color,
      '--white-label-primary-color': siteConfig.primary_color,
      '--white-label-secondary-color': siteConfig.secondary_color,
      '--blue-500': siteConfig.primary_color,
      '--highlight-text-color': siteConfig.primary_color,
      '--white-label-header-text-color': siteConfig.header_text_color,
      '--primary-color': siteConfig.primary_color,
    };

    Object.entries(themeVars).forEach(([key, value]) => {
      document.documentElement.style.setProperty(key, value);
    });
  }

  // getWhiteLabelAssets() {
  //   if (!window) throw new Error('Invalid environment');
  //   if (!window.location) throw new Error('Invalid environment');
  //   const hostname = window.location.host.toLowerCase();
  //   let selectedTheme = ASSETS.find(asset => asset.hostname === hostname);
  //   if (this.environment === 'DEV') {
  //     selectedTheme = ASSETS.find(asset => asset.hostname === hostname);
  //   } else if (this.environment === 'STAGE') {
  //     selectedTheme = ASSETS.find(asset => asset.hostname === hostname);
  //   } else if (this.environment === 'PROD') {
  //     selectedTheme = PRODASSETS.find(asset => asset.hostname === hostname);
  //   }
  //   return selectedTheme;
  // }
}
